import { FC, ReactNode } from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';
import Close from '@icons/Close';
import getTestId from '@functions/testId';
import { twMerge } from 'tailwind-merge';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
    overlayClassName?: string;
    closeButtonClassName?: string;
    modalCloseButtonTestingId?: string;
    testId?: string;
    children: ReactNode;
    appElement: HTMLElement;
    headerClassName?: string;
    contentClassName?: string;
};

const Modal: FC<Props> = ({
    isOpen,
    onClose,
    className,
    overlayClassName,
    closeButtonClassName,
    modalCloseButtonTestingId,
    testId,
    appElement,
    children,
    headerClassName,
    contentClassName,
}) => {
    const handleAfterOpen = () => {
        document.body.style.overflow = 'hidden';
    };

    const handleAfterClose = () => {
        document.body.removeAttribute('style');
    };

    return (
        <ReactModal
            isOpen={isOpen}
            className={twMerge(
                'tw-absolute tw-bottom-auto tw-left-[50%] tw-right-auto tw-top-[50%] -tw-mr-[50%] tw-flex tw-max-h-[calc(100%-42px)] tw-max-w-[calc(100%-24px)] -tw-translate-x-1/2 -tw-translate-y-1/2 tw-flex-col tw-overflow-x-hidden tw-overflow-y-hidden tw-rounded-md tw-border tw-border-solid tw-border-[rgba(0,0,0,0.2)] tw-bg-white tw-pb-3 tw-pl-3 tw-pr-0 tw-pt-3',
                className
            )}
            testId={getTestId(testId)}
            overlayClassName={cx('tw-fixed tw-inset-0 tw-bg-[rgba(0,0,0,0.35)] tw-z-[2000]', overlayClassName)}
            onAfterOpen={handleAfterOpen}
            onAfterClose={handleAfterClose}
            onRequestClose={onClose}
            appElement={appElement}
        >
            <header
                className={cx(
                    'tw-relative tw-z-[2] tw-mb-3 tw-flex tw-shrink-0 tw-flex-row-reverse tw-justify-between',
                    headerClassName
                )}
            >
                <button
                    className={cx(
                        'tw-mr-3 tw-flex tw-h-5 tw-w-5 !tw-bg-transparent [&_svg]:tw-fill-black [&_svg]:tw-transition-[fill] [&_svg]:tw-duration-300 [&_svg]:tw-ease-in-out hover:[&_svg]:tw-fill-teal-600',
                        closeButtonClassName
                    )}
                    data-testid={getTestId(modalCloseButtonTestingId)}
                    onClick={onClose}
                >
                    <Close />
                </button>
            </header>
            <div
                className={cx(
                    'tw-max-h-full tw-grow tw-overflow-y-auto tw-overflow-x-hidden tw-pr-3',
                    contentClassName
                )}
            >
                {children}
            </div>
        </ReactModal>
    );
};

export default Modal;
